import React, { PureComponent } from 'react';
import { DATE_FORMAT } from '../../api/api.types';
import {
  DeskOpeningExceptionModel, DeskOpeningModel, OutOfHoursType, OutOfHoursTypeOptions
} from '../../api/core/core.types';
import DayCard from './DayCard';
import dayjs from 'dayjs';

interface DeskOpeningOverviewProps {
  deskOpening?: DeskOpeningModel;
  deskOpeningException?: DeskOpeningExceptionModel;
  showButtons: boolean | null;
  onEdit: () => void;
  onDelete: () => void;
  onDuplicate: () => void;
}

export default class DeskOpeningOverview extends PureComponent<DeskOpeningOverviewProps> {

  getOutOfHoursType = (outOfHours: OutOfHoursType) => {
    const outOfHoursOption: any = OutOfHoursTypeOptions.find((o) => o.value === outOfHours);
    if (outOfHours) {
      if (outOfHours === OutOfHoursType.NOT_ALLOWED) return outOfHoursOption.label;

      return `Allowed (${outOfHoursOption.label})`;
    }

    return '';
  };

  render() {
    return (
      <div className="desk-opening-container">
        <div className="d-flex row align-items-center justify-content-between">
          <div className="d-flex row ml-2">
            { this.props.deskOpening && (
              <>
                <label className="mr-2 text-bold">Opening hours for period:</label>
                <div className="text-primary mr-1">{dayjs(this.props.deskOpening.validFrom).format(DATE_FORMAT)}</div>
                <div className="mr-1"> - </div>
                <div className="text-primary">{dayjs(this.props.deskOpening.validTo).format(DATE_FORMAT)}</div>
              </>
            )}
            { this.props.deskOpeningException && (
              <>
                <label className="mr-2 text-bold">Holiday:</label>
                <div className="text-primary mr-1">{dayjs(this.props.deskOpeningException.date).format(DATE_FORMAT)}</div>
              </>
            )}
          </div>
          {this.props.showButtons && (
            <div className="d-flex opening-button-container">
              <button type="button" className="btn btn-outline-secondary mr-1" onClick={this.props.onDelete}>DELETE</button>
              <button type="button" className="btn btn-outline-secondary mr-1" onClick={this.props.onDuplicate}>DUPLICATE</button>
              <button type="button" className="btn btn-primary" onClick={this.props.onEdit}>EDIT</button>
            </div>
          )}
        </div>
        { this.props.deskOpeningException && (
          <div className="d-flex ml-1 mt-3 justify-content-start">
            <DayCard
              day={dayjs(this.props.deskOpeningException.date).format('dddd')}
              isClosed={this.props.deskOpeningException.isClosed}
              openHoursExceptions={this.props.deskOpeningException.openHoursExceptions}
            />
          </div>
        )}
        { this.props.deskOpening && (
          <div className="d-flex ml-1 mt-3 justify-content-center">
            <DayCard
              day="MONDAY"
              isClosed={this.props.deskOpening.daysClosed.isMonClosed}
              openHours={this.props.deskOpening.openHours.filter((o) => o.dayOfWeek === 'MONDAY')}
            />
            <DayCard
              day="TUESDAY"
              isClosed={this.props.deskOpening.daysClosed.isTueClosed}
              openHours={this.props.deskOpening.openHours.filter((o) => o.dayOfWeek === 'TUESDAY')}
            />
            <DayCard
              day="WEDNESDAY"
              isClosed={this.props.deskOpening.daysClosed.isWedClosed}
              openHours={this.props.deskOpening.openHours.filter((o) => o.dayOfWeek === 'WEDNESDAY')}
            />
            <DayCard
              day="THURSDAY"
              isClosed={this.props.deskOpening.daysClosed.isThuClosed}
              openHours={this.props.deskOpening.openHours.filter((o) => o.dayOfWeek === 'THURSDAY')}
            />
            <DayCard
              day="FRIDAY"
              isClosed={this.props.deskOpening.daysClosed.isFriClosed}
              openHours={this.props.deskOpening.openHours.filter((o) => o.dayOfWeek === 'FRIDAY')}
            />
            <DayCard
              day="SATURDAY"
              isClosed={this.props.deskOpening.daysClosed.isSatClosed}
              openHours={this.props.deskOpening.openHours.filter((o) => o.dayOfWeek === 'SATURDAY')}
            />
            <DayCard
              day="SUNDAY"
              isClosed={this.props.deskOpening.daysClosed.isSunClosed}
              openHours={this.props.deskOpening.openHours.filter((o) => o.dayOfWeek === 'SUNDAY')}
            />
          </div>
        )}
        { this.props.deskOpening && (
          <>
            <div className="d-flex row info-container align-items-center mt-2">
              <label className="ml-2 align-items-center">Out of hours pickup: </label>
              <div className="col-2 d-flex">{this.getOutOfHoursType(this.props.deskOpening.pickupOutOfHoursType)}</div>
            </div>
            <div className="d-flex row info-container align-items-center">
              <label className="ml-2 d-flex">Out of hours drop-off: </label>
              <div className="col-2 d-flex">{this.getOutOfHoursType(this.props.deskOpening.returnOutOfHoursType)}</div>
            </div>
          </>
        )}
        { this.props.deskOpeningException && (
          <>
            <div className="d-flex row info-container align-items-center mt-2">
              <label className="ml-2 align-items-center">Out of hours pickup: </label>
              <div className="col-2 d-flex">{this.getOutOfHoursType(this.props.deskOpeningException.pickupOutOfHoursType)}</div>
            </div>
            <div className="d-flex row info-container align-items-center">
              <label className="ml-2 d-flex">Out of hours drop-off: </label>
              <div className="col-2 d-flex">{this.getOutOfHoursType(this.props.deskOpeningException.returnOutOfHoursType)}</div>
            </div>
          </>
        )}
      </div>
    );
  }
}
